<template>
  <div class="py-10 white--text" style="background-color: #19191b">
    <v-container>
      <v-row>
        <v-col cols="12" md="4" align="left" class="mt-6 pr-10">
          <div class="mb-4">
            <img :src="logo" />
          </div>
          <div>{{ desc }}</div>
        </v-col>
        <v-col cols="6" md="4" class="pl-4 pl-md-10 mt-6" align="left">
          <div class="mb-5">{{ product }}</div>
          <div v-for="x in products" :key="x.text" class="mb-5" style="cursor: pointer">
            <a :href="x.url" class="white--text" target="_blank">{{ x.text }}</a>
          </div>
        </v-col>
        <v-col cols="6" md="4" class="pl-4 pl-md-10 mt-6" align="left">
          <div class="mb-5">{{ company }}</div>
          <div v-for="x in companys" :key="x.text" class="mb-5" style="cursor: pointer">
            <a :href="x.url" class="white--text" target="_blank">{{ x.text }}</a>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="grey darken-1 mt-10 mb-10"></v-divider>
    <div class="d-sm-flex flex-wrap align-center justify-start px-4">
      <a :href="footer.text1Url" target="_blank" class="white--text text-no-wrap mr-4 mt-2">{{ footer.text1 }}</a>
      <div class="mr-4 mt-2">{{ footer.text1_1 }}</div>
      <div class="mr-4 mt-2">{{ footer.text2 }}</div>
      <div class="mr-4 mt-2">{{ footer.text3 }}</div>
      <div class="mr-4 mt-2">{{ footer.text4 }}</div>
      <div class="mr-4 mt-2">{{ footer.text5 }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require("@/assets/image/home/logo.svg"),
      desc: "小芋頭是一個集結人資系統、會員網站..等服務的一站式平台，為中小企業乃至個人商家提供各項解決方案",
      product: "產品",
      products: [
        {
          text: "小芋頭平台",
          url: "https://taro.kf-9595.com/",
        },
        {
          text: "小芋頭社群",
          url: "https://tarosms.kf-9595.com/",
        },
        {
          text: "小芋頭廣告",
          url: "https://taro.kf-9595.com/ads",
        },
      ],
      company: "公司",
      companys: [
        {
          text: "成為介紹人及代理商",
          url: "https://taro.kf-9595.com/upgrade",
        },
        {
          text: "合作公司意向書",
          url: "https://forms.gle/fatSbR5WGsDkLqEn9",
        },
        {
          text: "聯絡我們",
          url: "https://kingfong9595.wordpress.com/contact-taro/",
        },
        {
          text: "免責聲明",
          url: "/disclaimer",
        },
        {
          text: "隱私權政策",
          url: "/privacyPolicy",
        },
        {
          text: "會員服務條款",
          url: "/terms",
        },
      ],
      footer: {
        text1: "© 2022 金豐企業管理顧問股份有限公司",
        text1_1: "﹒統編 : 70413905",
        text1Url: "https://www.king-fong.com/",
        text2: "﹒小芋頭工作室",
        text3: "﹒高雄市左營區大順一路91號10樓之3",
        text4: "﹒免費服務專線電話",
        text5: "﹒0800-06-9595(0800-您來-教我教我)",
      },
    };
  },
  methods: {
    GoRouter() { },
  },
};
</script>
